import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useUserData } from "src/context/userContext";
import { DropdownIcon } from "../icons/ArrowIcons";
import { useEffect, useState } from "react";
import { fetchUserAsiakasListForPerson } from "src/data/person/PersonFunctions";
import { asiakas_fetch } from "src/data/asiakas/AsiakasFunctions";
import { cache_clear_ALL } from "../js/CacheFunctions";

export default function UserAsiakasSelectorDropdown({
  typographyProps,
  dropdownIconProps,
  iconButtonProps,
}) {
  const { user, userAsiakas, token, doSetUserAsiakas } = useUserData();
  const [userAsiakasList, setUserAsiakasList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const asynk = async () => {
      // get list of userAsiakkaat for person
      const _list = await fetchUserAsiakasListForPerson(user.personId, token);
      setUserAsiakasList(_list);
    };
    asynk();
  }, [user]);

  const handleAsiakasClick = async (asiakas) => {
    setAnchorEl(null);
    const _fetchResult = await asiakas_fetch(
      user,
      asiakas.asiakasId,
      token,
      null,
      asiakas.asiakasId
    );
    cache_clear_ALL();
    doSetUserAsiakas(_fetchResult.globalAsiakas);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  if (!userAsiakas)
    return (
      <Typography noWrap component="div" {...typographyProps}>
        betoni.online
      </Typography>
    );

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography noWrap component="div" {...typographyProps}>
          {userAsiakas.asiakasNimi}
        </Typography>
        {userAsiakasList && userAsiakasList.length > 1 && (
          <IconButton {...iconButtonProps} onClick={(event) => setAnchorEl(event.currentTarget)}>
            <DropdownIcon {...dropdownIconProps} />
          </IconButton>
        )}
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}>
        {userAsiakasList.map((asiakas, index) => (
          <MenuItem key={index} onClick={() => handleAsiakasClick(asiakas)} sx={{ width: 250 }}>
            {asiakas.asiakasNimi}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

UserAsiakasSelectorDropdown.propTypes = {
  typographyProps: PropTypes.object,
  dropdownIconProps: PropTypes.object,
  iconButtonProps: PropTypes.object,
};
